<ng-container *ngrxLet="packingListResource$ as packingListResource">
  <ng-container *ngrxLet="layoutResource$ as layoutResource">
    <ng-container *ngrxLet="validationTranslations$ as validationTranslations">
      <hazmatsuite-next-modal
        [title]="packingListResource['OverpackDetailsHeader']"
        [showModal]="show"
        [confirmButtonLabel]="
          isEdit
            ? packingListResource['SaveOverpack']
            : showForm
            ? packingListResource['AddOverpack']
            : ''
        "
        (closeModal)="closeModal()"
        (confirm)="save(isEdit)"
      >
        <ng-container *ngIf="showOptions && !this.showForm; else form">
          <form [formGroup]="overpackSelectionFormGroup" class="col-12">
            <select class="form-control" formControlName="overpackId">
              <option></option>
              <option [value]="item.Id" *ngFor="let item of overpackItems">
                {{ item.Name }}
              </option>
            </select>
          </form>
          <button
            type="button"
            class="btn btn-iconed btn-iconed-primary mt-5"
            (click)="select()"
          >
            {{ packingListResource['SelectOverpack'] }}
            <i class="btn-icon ifc-custom ifc-arrow-right"></i>
          </button>
          <hr />
          <button
            type="button"
            class="btn btn-iconed btn-iconed-primary mt-5"
            (click)="createNew()"
          >
            {{ packingListResource['AddOverpack'] }}
            <i class="btn-icon ifc-custom ifc-add"></i>
          </button>
        </ng-container>
      </hazmatsuite-next-modal>

      <ng-template #form>
        <form [formGroup]="formGroup" class="col-12">
          <div class="form-group row">
            <label class="col-sm-3 col-form-label h4">{{
              packingListResource['Amount']
            }}</label>
            <div class="col-sm-9">
              <div class="row form-row">
                <div class="col-sm-3">
                  <input
                    formControlName="amount"
                    class="form-control"
                    type="number"
                    step="1"
                  />
                  <span
                    *ngIf="
                      amount?.invalid && (amount?.dirty || amount?.touched)
                    "
                    class="text-danger"
                  >
                    {{ validationTranslations['PositiveInteger'] }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label h4">{{
              packingListResource['OverpackType']
            }}</label>
            <div class="col-sm-9">
              <div class="row form-row">
                <div class="col-sm-12">
                  <input formControlName="packingType" class="form-control" />
                  <span
                    *ngIf="
                      packingType?.invalid &&
                      (packingType?.dirty || packingType?.touched)
                    "
                    class="text-danger"
                  >
                    {{ validationTranslations['InputRequired'] }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row">
            <label class="col-sm-3 col-form-label h4">{{
              packingListResource['OverpackIdentification']
            }}</label>
            <div class="col-sm-9">
              <div class="row form-row">
                <div class="col-sm-12">
                  <input
                    formControlName="identification"
                    class="form-control"
                  />
                  <span
                    *ngIf="
                      identification?.invalid &&
                      (identification?.dirty || identification?.touched)
                    "
                    class="text-danger"
                  >
                    {{ validationTranslations['InputRequired'] }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-container>
